import { render, staticRenderFns } from "./SpaceRelatedProducts.vue?vue&type=template&id=db18bb46&scoped=true"
import script from "./SpaceRelatedProducts.vue?vue&type=script&lang=js"
export * from "./SpaceRelatedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db18bb46",
  null
  
)

export default component.exports